import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Users, Globe, BarChart3, Bot, Clock, CheckCircle2, Pencil } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const statusColors = { draft: "text-yellow-400 bg-yellow-400/10", revision: "text-orange-400 bg-orange-400/10", live: "text-green-400 bg-green-400/10" };
const packageLabels = { website_only: "Website", website_dashboard: "Website + Dashboard", website_companion: "Website + Companion", website_both: "Website + Both" };
const packageIcons = { website_only: Globe, website_dashboard: BarChart3, website_companion: Bot, website_both: BarChart3 };

export default function ClientList() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/clients`, { withCredentials: true })
      .then(res => setClients(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-20"><div className="w-6 h-6 border-2 border-[#C9A84C] border-t-transparent rounded-full animate-spin"></div></div>;

  const stats = {
    total: clients.length,
    live: clients.filter(c => c.status === "live").length,
    draft: clients.filter(c => c.status === "draft").length,
    revision: clients.filter(c => c.status === "revision").length,
  };

  return (
    <div data-testid="client-list-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white">Clients</h1>
        <div className="flex items-center gap-3 text-xs">
          <span className="text-[#9999B3]">{stats.total} total</span>
          <span className="text-green-400">{stats.live} live</span>
          <span className="text-orange-400">{stats.revision} revision</span>
          <span className="text-yellow-400">{stats.draft} draft</span>
        </div>
      </div>
      
      <div className="grid gap-3">
        {clients.map(client => {
          const PkgIcon = packageIcons[client.package] || Globe;
          return (
            <Link to={`/dashboard/client/${client.id}`} key={client.id} className="group bg-[#12121F] border border-[#252540] rounded-lg p-4 flex items-center justify-between hover:border-[#C9A84C]/30 transition-all" data-testid={`client-${client.id}`}>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#C9A84C]/10 flex items-center justify-center flex-shrink-0">
                  <PkgIcon className="w-5 h-5 text-[#C9A84C]" />
                </div>
                <div>
                  <h3 className="text-white font-semibold text-sm group-hover:text-[#C9A84C] transition-colors">{client.business_name}</h3>
                  <p className="text-[#9999B3] text-xs">{client.name} &middot; {packageLabels[client.package] || client.package}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                {client.website_url && <span className="text-[#6B6B85] text-xs hidden sm:block">{client.website_url}</span>}
                <span className={`text-xs px-2.5 py-1 rounded-full font-medium capitalize ${statusColors[client.status] || 'text-[#9999B3] bg-[#252540]'}`}>
                  {client.status}
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
